const updates = [
  { date: '2026.07.28', title: '《咒术回战》最新话272话已更新，宿傩最终形态降临', tag: '热门连载' },
  { date: '2026.07.28', title: '《海贼王》第1130话：路飞VS黑胡子终极对决开战', tag: '必看' },
  { date: '2026.07.27', title: '《间谍过家家》番外篇上线，安妮亚校园祭大冒险', tag: '新番推荐' },
  { date: '2026.07.27', title: '平台新增"阅读历史云同步"功能，换设备追漫不掉进度', tag: '功能更新' },
  { date: '2026.07.26', title: '《葬送的芙莉莲》第二季预告公开，2026年秋季开播', tag: '资讯' },
  { date: '2026.07.26', title: '《坂本日常》第200话里程碑达成，官方庆祝活动进行中', tag: '热门连载' },
  { date: '2026.07.25', title: '2026夏季新番专题上线，20部新连载一口气追个够', tag: '专题' },
  { date: '2026.07.25', title: '《怪兽8号》动画化纪念，原作漫画限时免费阅读活动开启', tag: '福利' },
  { date: '2026.07.24', title: '《地狱乐》第二季制作决定，粉丝欢呼雀跃', tag: '资讯' },
];

export default function Updates() {
  return (
    <section id="updates" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-4xl mx-auto">
        <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-900 mb-2 text-center">
          最新动态
        </h2>
        <p className="text-foreground-500 text-sm text-center mb-10">漫画世界每一天都有新精彩</p>

        <div className="relative pl-8 border-l-2 border-primary-200">
          {updates.map((item, i) => (
            <div key={i} className="relative mb-8 last:mb-0">
              <div className="absolute -left-[calc(2rem+5px)] top-1 w-3 h-3 rounded-full bg-primary-500 ring-4 ring-background-50"></div>
              <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4">
                <span className="text-xs text-foreground-400 font-medium whitespace-nowrap">{item.date}</span>
                <span className={`inline-block px-2 py-0.5 rounded text-[10px] font-semibold whitespace-nowrap ${
                  item.tag === '热门连载' || item.tag === '必看' ? 'bg-primary-100 text-primary-700' :
                  item.tag === '福利' ? 'bg-accent-100 text-accent-700' :
                  'bg-secondary-100 text-secondary-700'
                }`}>{item.tag}</span>
                <p className="text-sm text-foreground-700 leading-relaxed">{item.title}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}